<template>
  <v-dialog
    max-width="500"
    v-model="dialog"
    scrollable
    @keydown.esc="dialog = false"
    :fullscreen="$vuetify.breakpoint.xs"
  >
    <v-card :loading="loading">
      <v-system-bar window>
        Anlass {{ canEdit ? "bearbeiten" : "" }}
        <v-spacer />
        <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-system-bar>

      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Beschreibung</v-list-item-title>
            <v-list-item-subtitle>
              {{ item.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="item.startDate && item.endDate">
          <v-list-item-content>
            <v-list-item-title>Zeitraum</v-list-item-title>
            <v-list-item-subtitle>{{
              formatDatespan(item.startDate, item.endDate)
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list subheader>
        <v-subheader>Erezuger</v-subheader>
        <PersonItem :value="$_profilePerson" />
        <v-subheader>Mitglieder</v-subheader>

        <PersonItem
          :value="member"
          v-for="member in item.members"
          :key="member.id"
          ><v-btn
            v-if="canEdit"
            :disabled="addingMember"
            icon
            @click.stop="removeMember(member)"
            ><v-icon>mdi-delete</v-icon></v-btn
          ></PersonItem
        >
        <template v-if="canEdit">
          <v-divider />
          <v-subheader>Mitglied hinzufügen</v-subheader>
          <v-list-item>
            <v-list-item-content>
              <PersonInput
                single-line
                :disabled="addingMember"
                hide-details
                dense
                v-model="newMember"
                group="staff"
                clearable
              />
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                :disabled="addingMember || newMember == null"
                icon
                @click="addMember"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>

      <v-divider />
      <v-card-actions>
        <v-btn color="error" text @click="trash" v-if="canEdit">löschen</v-btn>
        <v-spacer /><v-btn
          text
          @click="dialog = false"
          :disabled="newMember != null"
          >schliessen</v-btn
        ></v-card-actions
      >
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import CurrencyValue from "common/components/CurrencyValue";
import PersonItem from "common/components/PersonItem.vue";
import PersonInput from "common/components/PersonInput.vue";
import { formatDatespan } from "common/utils/date.js";

export default defineComponent({
  components: { CurrencyValue, PersonItem, PersonInput },
  props: ["id"],
  data: () => ({
    item: { description: "", startDate: "", endDate: "", members: [] },
    loading: false,
    addingMember: false,
    newMember: null,
    dialog: true,
  }),
  computed: {
    canEdit() {
      return (
        this.$_hasRole("financeAdmin") || this.$_isPerson(this.item.creator)
      );
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.$router.push({
          name: "InvoiceEvents2",
        });
      }
    },
    id() {
      this.fetchData();
    },
  },

  methods: {
    formatDatespan,
    async addMember() {
      if (this.newMember) {
        this.addingMember = true;
        await this.apiPost({
          resource: "finance/invoiceeventmember",
          data: {
            action: "add",
            event: this.id,
            person: this.newMember.id,
          },
        });
        await this.fetchData();

        this.newMember = null;
        this.addingMember = false;
      }
    },
    async removeMember(member) {
      this.addingMember = true;
      await this.apiPost({
        resource: "finance/invoiceeventmember",
        data: {
          action: "remove",
          event: this.id,
          person: member.id,
        },
      });
      await this.fetchData();
      this.addingMember = false;
    },
    async fetchData() {
      if (this.id > 0) {
        this.loading = true;
        this.item = await this.apiGet({
          resource: "finance/invoiceevent",
          id: this.id,
        });
        this.loading = false;
      }
    },
    async trash() {
      if (
        await this.$root.confirm({
          title: "Anlass löschen",
          message: "Alle Daten werden gelöscht. Wirklich löschen?",
          color: "error",
        })
      ) {
        await this.apiDelete({
          resource: "finance/invoiceevent",
          id: this.id,
        });
        this.$emit("updated");
        this.dialog = false;
      }
    },
  },

  async created() {
    this.fetchData();
  },
});
</script>
